export default class Customer {
  /**
   *
   * @param customerJSON
   */
  constructor(customerJSON) {

    /**
     * @type {number}
     */
    this.id = customerJSON.id;

    /**
     * @type {string}
     */
    this.name = customerJSON.name;
    this.lastSynchronized = customerJSON.lastSynchronized;
    this.lastSynchronizeTry = customerJSON.lastSynchronizeTry;
    this.nextSynchronizeTry = customerJSON.nextSynchronizeTry;
    this.updatedDate = customerJSON.updatedDate;
    this.mail = customerJSON.mail;
    this.appLoginDomain = customerJSON.appLoginDomain;
    this.accountAuthority = customerJSON.accountAuthority;
    this.userCount = customerJSON.remoteUserCount;
    this.localUserCount = customerJSON.localUserCount;
    this.usersWithTokenCount = customerJSON.usersWithTokenCount;
    this.remoteAccountProviderCount = customerJSON.remoteAccountProviderCount;
    this.default = !!customerJSON.default;

    /**
     * idicates some states to this customer instance
     * @type {boolean}
     */
    this.loading = false;
  }
}
